<template>
  <address
    class="contact-address"
    itemprop="address"
    itemscope
    itemtype="http://schema.org/PostalAddress"
  >
    <LucideHome />
    <span>
      <span itemprop="addressRegion">Cuneo</span> •
      <span itemprop="addressCountry">{{ $t('Italia') }}</span>
    </span>
  </address>
</template>
